export default __webpack_public_path__ + "static/media/icn_list_guide_banner_3.c7fce264.svg";